input[type='checkbox'].switch {
    display: none;
}
input[type='checkbox'].switch + label.label {
    position: relative;
    display: inline-block;
    width: 100%;
    cursor: pointer;
    text-align: left;
    padding: 16px 44px 16px 12px;
    height: auto;
}
input[type='checkbox'].switch + label.label.reverse {
    text-align: right;
    padding: 16px 12px 16px 44px;
}
input[type='checkbox'].switch + .label:before,
input[type='checkbox'].switch + .label:after {
    content: '';
    position: absolute;
    margin: 0;
    outline: 0;
    top: 50%;
    -ms-transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
input[type='checkbox'].switch + .label:hover:before {
    border-color: #9e9e9e;
}
input[type='checkbox'].switch + .label:before {
    right: 0;
    left: initial;
    width: 34px;
    height: 14px;
    background-color: #9e9e9e !important; /* Override B2B style */
    border-color: #9e9e9e;
    border-radius: 8px;
}
input[type='checkbox'].switch + .label.reverse:before {
    right: initial;
    left: 0;
}
input[type='checkbox'].switch + .label:after {
    right: 14px;
    left: initial;
    width: 20px;
    height: 20px;
    background-color: #fafafa;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098),
        0 1px 5px 0 rgba(0, 0, 0, 0.084);
}

input[type='checkbox'].switch + .label.reverse:after {
    right: initial;
    left: 0;
}

input[type='checkbox'].switch:checked + .label:before {
    background-color: var(--lime) !important;
    border-color: var(--lime) !important;
}
input[type='checkbox'].switch:checked + .label:after {
    background-color: var(--white);
    -ms-transform: translate(80%, -50%);
    -webkit-transform: translate(80%, -50%);
    transform: translate(80%, -50%);
}
input[type='checkbox'].switch:checked + .label .toggle--on {
    display: inline-block;
}
input[type='checkbox'].switch:checked + .label .toggle--off {
    display: none;
}
